import { Component, Inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { MatAlert } from '@lhn/mat-alert';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../shared/confirmation-dialog.component';
import { CONFIGURAZIONE, Configurazione, Services, SERVIZI } from '../shared/app';
import * as moment from 'moment';

@Component({
  selector: 'app-prenotazioni',
  templateUrl: './prenotazioni.component.html'
})
export class PrenotazioniComponent {

  public prns: any[] = [];
  public status = ['In attesa di conferma', 'Confermata', 'Annullata dal gestore', 'Annullata dal cliente'];
  public sc: any;

  constructor(private alert: MatAlert, private dialog: MatDialog, @Inject(CONFIGURAZIONE) public configuration: Configurazione,
    @Inject(SERVIZI) public services: Services) {
    if (this.services.user) {
      const uids = [];
      if (this.services.user.uid) {
        uids.push(this.services.user.uid);
      }
      if (this.services.user.phoneNumber) {
        uids.push(this.services.user.phoneNumber);
      }
      if (this.services.user.email) {
        uids.push(this.services.user.email);
      }
      if(uids.length == 0){
        return;
      }
      var t = moment().localeData();
      this.services.firestore.collection("prenotazioni", ref => ref.where("uid", "in", uids).orderBy('creazione', 'desc')).get().subscribe(_prns => {
        this.prns = _prns.docs.map(_prn => Object.assign(<any>_prn.data(), {
          id: _prn.id,
          data: moment(<any>_prn.data().data).lang('IT').format('DD/MM/YYYY ddd'),
          fulldata: <any>_prn.data().data,
          creazione: new Date((<any>_prn.data()).creazione.seconds * 1000)
        }));
      });
    } else {
      this.prns = [];
    }
    this.sc = this.configuration.setup_configurazione;
  }

  async Annulla(prn) {
    const oldStatus = prn.stato;
    const question = this.dialog.open(ConfirmationDialogComponent, {
      
      panelClass: 'dialog-container-custom',
      data: "Sei sicuro?"
    });
    const confirm = await question.afterClosed().toPromise();
    if (confirm) {
      this.services.prenotazioni.doc(prn.id).update({ stato: 3, sync: true }).then(() => {
        this.alert.show('La prenotazione è stata annullata', `Riceverà una conferma via email o WhatsApp.`);
      });
      if(oldStatus == 1) this.UpdatePrenotazioniAuto(prn);
    }
  }

  async UpdatePrenotazioniAuto(prn){
    const pid = `${moment(prn.fulldata).format('YYYYMMDD')}-${prn.ora}`;
    const prn_auto = await this.services.prenotazioni_automatiche.doc(pid).get().toPromise();
    const totale = prn.bambini + prn.adulti;
    if(prn_auto.exists && prn_auto.data().disponibili < this.sc.MaxCoperti){
      this.services.prenotazioni_automatiche.doc(pid).update({ disponibili: prn_auto.data().disponibili + totale });
    }
  }
}
